import React, { useState } from "react";
import "./ContactForm.css";
function ContactForm() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const handleSubmit = async (event) => {
    event.preventDefault();

    // Validation
    const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;

    if (!name || !email) {
      alert("Please enter all required fields.");
      return;
    }

    if (!emailPattern.test(email)) {
      alert("Please enter a valid email address.");
      return;
    }

    try {
      const response = await fetch(
        "https://realtybase.sharecapacity.com/user/email",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            name,
            email,
            message,
          }),
        }
      );

      const responseData = await response.json();
      //console.log(responseData.message, "check");
      alert(responseData.message);

      // Clear form fields by resetting state
      setName("");
      setEmail("");
      setMessage("");
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  return (
    <div className="ContactForm">
      <div className="container py-5">
        <div className="row d-flex justify-content-center">
          <div className="col-xl-4 col-md-6 d-flex justify-content-center justify-content-lg-start">
            <div>
              <h1
                className="font-face-PlusJakartaSans-Bold"
                // style={{ fontWeight: "600" }}
              >
                Send Your <span className="d-lg-block">Message</span>
              </h1>
              <h5 className="mt-lg-4 font-face-PlusJakartaSans-Regular">
                support@realtybase.com
              </h5>
            </div>
          </div>
          <div className="col-xl-4 col-md-6 mt-4 mt-md-0">
            <form
              className="d-flex flex-column gap-3"
              onSubmit={handleSubmit}
              id="myForm"
            >
              <input
                placeholder="Full Name"
                id="name"
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
              <input
                placeholder="Email Address"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                type="text"
              />
              <textarea
                rows={6}
                placeholder="Message"
                id="message"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
              />
              <button type="submit" className="font-face-PlusJakartaSans-Bold">
                Send Message
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ContactForm;
